export default __webpack_public_path__ + "static/media/play.3b2cf7cc.svg";